module.exports = __webpack_public_path__ + "images/marketing/peeps/lisa_bradley.png";